export default "__VITE_ASSET__tsEaO0ro__"